<template>
  <tabs
    :tabs="eocTabs"
    :selectedTab="selectedTab"
    :showing="showing"
    :bgClass="'bg-white'"
    :borderClass="'border-color-light-gray bordered-tab-item'"
    :itemTextClass="'color-custom-dark-grey'"
    :itemBGClass="'bg-dark-gray'"
    :shadowPosition="'top'"
    @select-tab="selectTab"
    @remove-tab="removeTab"
    @add-tab="addTab"
    @tabs-container-height-change="setTabsContainerHeight"
    @update-tab="updateTab"
    ref="tabs"
  />
</template>

<script>
import Tabs from "../workspace/Tabs.vue";
import { mapGetters, mapMutations, mapState } from "vuex";
import eocServer from "../../server/eoc";

export default {
  name: "EocTabs",
  components: { Tabs },
  props: ["showing"],
  methods: {
    ...mapMutations("layout", ["setEocTabs", "setSelectedEocTab"]),
    selectTab(selectedTab) {
      this.setSelectedEocTab(selectedTab);
    },
    removeTab(tabIndex) {
      if (this.eocTabs[tabIndex].key == this.selectedTab) {
        if (tabIndex < this.eocTabs.length - 1) {
          this.setSelectedEocTab(this.eocTabs[tabIndex + 1].key);
        } else {
          this.setSelectedEocTab(this.eocTabs[tabIndex - 1].key);
        }
      }
      const newTabs = [...this.eocTabs];
      newTabs.splice(tabIndex, 1);
      this.setEocTabs(newTabs);
    },
    addTab(tab) {
      if (this.eocTabs.map(tab => tab.key).indexOf(tab.key) == -1) {
        const newTabs = [...this.eocTabs];
        newTabs.push(tab);
        this.setEocTabs(newTabs);
      }
      this.selectTab(tab.key);
    },
    setTabsContainerHeight(newHeight) {
      this.$emit("tabs-container-height-change", newHeight);
    },
    refreshShowingTab() {
      this.$refs.refreshShowingTab();
    },
    updateTab(updateData) {
      const index = updateData.tabIndex;
      const data = updateData.data;
      this.eocTabs[index].text = data.text;
      this.setEocTabs(this.eocTabs);
    }
  },
  computed: {
    ...mapGetters("client", ["listeners"]),
    ...mapState("layout", {
      eocTabs: state => state.eocTabs,
      selectedTab: state => state.selectedEocTab
    })
  },
  watch: {
    "listeners.fetchEoc": async function(newValue, oldValue) {
      const listenerEocs = Object.keys(newValue);
      for (let index = 0; index < listenerEocs.length; index++) {
        const listenerEoc = listenerEocs[index];
        if (newValue[listenerEoc] != oldValue[listenerEoc]) {
          const newTabs = [...this.eocTabs];
          for (let index2 = 0; index2 < newTabs.length; index2++) {
            const tab = newTabs[index2];
            if (tab.props.eocId == listenerEoc) {
              const eoc = await eocServer.get(listenerEoc);
              newTabs[index2].text = this.formatEocObj(eoc);
            }
          }
          this.setEocTabs(newTabs);
        }
      }
    }
  }
};
</script>
